<head>
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
</head>

<nav class="navbar navbar-expand-lg navbar-light fixed-top mb-5">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#conteudoNavbarSuportado" aria-controls="conteudoNavbarSuportado" aria-expanded="false" aria-label="Alterna navegação">
  <span class="navbar-toggler-icon"></span>
 </button>

 <div class="collapse navbar-collapse justify-content-center" id="conteudoNavbarSuportado">
      <ul class="navbar-nav mr-auto d-flex align-items-center">

          <li class="nav-item active">
         <!--definir imagem logo-->
          <img src="https://i.imgur.com/5KOEUob.png" alt="Logo Repassa" width ="80px" height="80px" class="img-fluid" >
         <!--/definir imagem logo-->
          </li>
      </ul>

      <ul class="navbar-nav ml-auto d-flex align-items-center">
          <!--SobreNós-->
          <li class="nav-item">
              <div class="form-group">
                <input type="text" class="form-control mt-3" placeholder="Buscar postagem por título"
                  [(ngModel)]='tituloPost' (keyup)='findByTituloPostagem()'>
            </div>
          </li>
          <!--/SobreNós-->

          <!--BotãoEntrar-->
          <li class="nav-item">
          <button routerLink='/home' class="btn follow ml-3" type="submit">Sair</button>
          </li>
          <!--BotãoEntrar-->
      </ul>
  </div>
</nav>

  <div class="row mt-5" >
  <!-- /Parte fixa esquerda Pag -->
    <div class="col-md-3 position-fixed lado-esquerdo" id="feed">
      <div class="d-flex justify-content-center" id="perfilLateral">
        <div class="card p-5 mt-2 border">
          <img width="80px" height="80px" src="{{foto}}" class="rounded-circle">
          <div class="media-body">
            <div class="d-flex flex-row justify-content-between">
              <h5 class="mr-5 mt-3 font-weight-bold">Olá, {{nome}}!</h5>
            </div>
          </div>
          <ul class="list pl-0">
            <li>Perfil</li>
            <li><a class="edit-perfil" [routerLink]="['/user-edit', id]" >Editar perfil</a></li>
            <li>Amigos</li>
            <li>Configurações</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- /Parte fixa esquerda Pag -->
  
    <!-- postagens -->
    <div class="col-md-6 postagens pt-5">
      <div class="card mt-5" id="bodypostagem">
        <div class="card-header">
          <p class="card-text mt-3 mb-3">
            <button type="button" class="btn btn-md ml-5" style="width: 80%" data-toggle="modal"
              data-target="#novaPostagem">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Olá {{nome}}, escreva sua publicação aqui!
            </button>
          </p>
          <hr />
          <div class="container-fluid d-flex justify-content-center">
            <label class="btn btn-default mr-5" data-toggle="modal" data-target="#novaPostagem"><img class="iconbuscar"
                src="https://i.imgur.com/RxsmP9u.png" />
              Foto <input type="button" hidden />
            </label>
            <label class="btn btn-default mr-5" data-toggle="modal" data-target="#novaPostagem"><img class="iconbuscar"
                src="https://i.imgur.com/by6kzAb.png" />
              Vídeo <input type="button" hidden />
            </label>
  
  
          </div>
        </div>
      </div>
  
      <nav>
        <div class="nav nav-tabs d-flex justify-content-center mt-3" id="nav-tab" role="tablist">
          <a class="nav-item nav-link active font-weight-bold navstyle" id="nav-todasPostagens" data-toggle="tab"
            href="#todasPostagens" role="tab" aria-controls="nav-todasPostagens" aria-selected="true">Todas as
            Postagens</a>
  
          <a (click)='findByIdUser()' class="nav-item nav-link font-weight-bold navstyle" id="nav-minhasPostagens-tab"
            data-toggle="tab" href="#minhasPostagens" role="tab" aria-controls="nav-minhasPostagens"
            aria-selected="false">Minhas Postagens</a>
        </div>
      </nav>
  
      <div class="tab-content mt-3" id="nav-tabContent">
        <!-- Todas as Postagens -->
        <div class="tab-pane fade show active" id="todasPostagens" role="tabpanel"
          aria-labelledby="nav-todasPostagens-tab">
          
          <div class="row align-items-center">
  
            <div class="card border-secondary mt-3 mb-3 w-100 bodypost"
              *ngFor='let item of listaPostagens | orderBy: key : reverse'>
              <!--for aqui-->
  
              <div class="card-header color-header border-secondary">
                <div class=" d-flex justify-content-between align-items-center">
                  <div class="d-flex justify-content-between align-items-center ">
                    <div class="mr-2">
  
                      <img class="rounded-circle" src="{{item.email.foto}}" alt="Imagem do user" width="50px"
                        height="50px" class="rounded-circle">
                    </div>
                    <div class="ml-2 mt-2">
                      <div class="h5 m-0 postfonth">{{item.email.nome}}</div>
                      <div>
                        <p class="text-muted"> <i class="fa fa-clock-o" aria-hidden="true"></i>{{item.data |
                          date: 'dd/MM/yyyy'}} às
                          {{item.data | date: 'HH:mm'}}</p>
                      </div>
                    </div>
                  </div>
  
                  <div class="d-flex justify-content-end">
                    <h5 class="mtema">
                      <span class="tema-font">Tema: {{item.tema.descricao}}</span> <img src="" class="iconcard1">
                    </h5>
                  </div>
                </div>
              </div>
  
              <div class="card-body">
                <h5 class="card-title postfonth1 mb-3">{{item.titulo}}</h5>
                <p class="card-text mb-5">{{item.texto}}</p>
  
                <img src="{{item.img}}" width="100%" height="100%" alt="" />
                <div class="d-flex justify-content-end socials p-2 py-3"><img src="https://i.imgur.com/aFcH3Qz.png"
                  height="20px" width="20px"><a href="https://api.whatsapp.com/send?phone=5511975225085" target="_blank"><img src="https://i.imgur.com/HF6yrc7.png" height="20px"
                  width="20px"></a><img src="https://i.imgur.com/9TeRUsD.png" height="20px" width="20px">
              </div>
              </div>
            </div>
          </div>
          </div>
          <!-- /Todas as Postagens --> 
  
          <!-- Minhas Postagens -->
          <div class="tab-pane fade show active" id="minhasPostagens" role="tabpanel"
            aria-labelledby="nav-minhasPostagens-tab">
            <div class="row align-items-center">
              <div class="card border-secondary mt-3 mb-3 w-100 bodypost"
                *ngFor='let item of user.postagem | orderBy: key : reverse'>
                <!--for aqui-->
  
                <div class="card-header color-header border-secondary">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="mr-2">
                        <img class="rounded-circle" width="45" src="{{foto}}" alt="Imagem do user" width="50px"
                          height="50px" class="rounded-circle">
                      </div>
                      <div class="ml-2 mt-2">
                        <div class="h5 m-0 postfonth">{{nome}}</div>
                        <div class="h7 text-muted">
                          <p class="text-muted"> <i class="fa fa-clock-o" aria-hidden="true"></i>{{item.data | date:
                            'dd/MM/yyyy'}} às
                            {{item.data | date: 'HH:mm'}} </p>
                        </div>
                      </div>
                    </div>
                    <div class="dropdown">
                      <button class="btn btn-light dropdown-toggle mt-0" type="button" id="gedf-drop1"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-ellipsis-h"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="gedf-drop1">
  
                        <a [routerLink]="['/postagem-edit', item.id]" class="text-info dropdown-item">Editar
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
                        <a [routerLink]="['/postagem-delete', item.id]" class="text-danger dropdown-item">Excluir <i
                            class="fa fa-trash-o" aria-hidden="true"></i></a>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-0">
                  <h5 class="mtema">
                    <span class="tema-font">Tema: {{item.tema.descricao}}</span> <img src="" class="iconcard1">
  
                  </h5>
                </div>
                </div>
  
                <div class="card-body text-center">
                  <h5 class="card-title postfonth1">{{item.titulo}}</h5>
  
                  <p class="card-text mt-3">{{item.texto}}</p>
                  <img src="{{item.img}}" width="100%" height="100%" alt="" />
  
                </div>
              </div>
            </div>
          </div>
          <!-- /Minhas Postagens -->
        </div>
    </div>
    <!-- /postagens -->
  
    <!--Amigos  e campanhas- Lateral Esquerda-->
    <div class="col-md-3 position-fixed lateral-direita lado-direito">
      <!--amigos-->
      <div class="container mt-2 d-flex justify-content-center">
        <div class="card p-3 card-amigos">
          <h5 id="titulo-amigos">Sugestões de amigos</h5>
          <div class="d-flex justify-content-between mt-2 align-items-center">
            <div class="d-flex flex-row"> <img src="https://avatars.githubusercontent.com/u/50744116?v=4" class="rounded-circle" width="45">
              <div class="d-flex flex-column ml-1 about"> <span class="nome font-weight-bold">Thiago Lima</span> <small>585
                  amigos</small> </div>
            </div> <button class="btn btn-sm follow">Seguir</button>
          </div>
          <hr>
          <div class="d-flex justify-content-between mt-2 align-items-center">
            <div class="d-flex flex-row"> <img src="https://avatars.githubusercontent.com/u/57823621?v=4" class="rounded-circle" width="45">
              <div class="d-flex flex-column ml-1 about"> <span class="nome font-weight-bold">Ed Nascimento</span> <small>2085
                  amigos</small> </div>
            </div> <button class="btn  btn-sm follow">Seguir</button>
          </div>
        </div>
      </div>
      <!--amigos-->
      <!--campanhas-->
        <div class="container mt-3 d-flex justify-content-center">
          <div class="card p-3 card-amigos">
            <h5 id="titulo-campanhas">Campanhas</h5>
            <div class="d-flex justify-content-between mt-2 align-items-center">
              <div class="d-flex flex-row"> <img src="https://i.imgur.com/TNFuuxG.jpeg" class="rounded-circle" width="45" height="45">
                <div class="d-flex flex-column ml-1 about"> <span class="nome font-weight-bold">Campanha do agasalho</span> <small>500
                    doadores</small> </div>
              </div> <button class="btn btn-sm doar">Doar</button>
            </div>
            <hr>
            <div class="d-flex justify-content-between mt-2 align-items-center">
              <div class="d-flex flex-row"> <img src="https://curearthritis.org/wp-content/uploads/2019/11/Snow-man.jpeg" class="rounded-circle" width="45" height="45">
                <div class="d-flex flex-column ml-1 about"> <span class="nome font-weight-bold">Inverno solidário</span> <small>200
                    doadores</small> </div>
              </div> <button class="btn  btn-sm doar">Doar</button>
            </div>
            <!-- <div class="d-flex justify-content-between mt-2 align-items-center">
              <div class="d-flex flex-row"> <img src="https://media-exp1.licdn.com/dms/image/C4E03AQFUaZ1exqKyRg/profile-displayphoto-shrink_800_800/0/1601560644196?e=1628726400&v=beta&t=Y6XdWLLUOOl_SrAJquIhfwaFRgeVbgprev298qRSsbc" class="rounded-circle" width="45">
                <div class="d-flex flex-column ml-1 about"> <span class="nome">Geandro Araujo</span> <small>100
                    doadores</small> </div>
              </div> <button class="btn btn-sm doar">Doar</button>
            </div> -->
          </div>
        </div>
      </div>
      <!--campanhas-->
  </div>
  <!--Amigos  e campanhas- Lateral Esquerda-->
  
  <!-- Modal postagem -->
  <div class="modal fade blur" id="novaPostagem" tabindex="-1" role="dialog" aria-labelledby="TituloModalCentralizado"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header colormodaltitle">
          <h5 class="modal-title modaltitle" id="TituloModalCentralizado">
            Nova Postagem
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
  
        <div class="modal-body" id="modalheight">
          <div class="form-group">
            <label for="tema" class="modaltitle">Escolha um tema:</label>
            <select [(ngModel)]='idTema' (change)='findByIdTema()' class="form-control" name="tema" id="tema">
              <option *ngFor='let item of listaTemas ' value="{{item.id}}">{{item.descricao}}
  
              </option>
            </select>
  
            <label for="titulo" class="modaltitle">Título</label>
            <input [(ngModel)]='postagem.titulo' type="text" class="form-control" id="titulo"
              placeholder="Digite o título" />
  
            <label for="texto" class="modaltitle">Texto</label>
            <textarea [(ngModel)]='postagem.texto' class="form-control" name="texto" id="texto" rows="3"
              placeholder="O que você está pensando?"></textarea>
  
            <label for="imagem" class="modaltitle">Imagem</label>
            <input [(ngModel)]='postagem.img' type="text" class="form-control" id="imagem" placeholder="Adicione o link da sua imagem aqui" />
  
  
            <div class="container">
              <div class="row">
  
                <button data-dismiss="modal" routerLink='/tema' class="btn-cadastrar-tema mt-3">
                  Cadastrar novo tema
                </button>
              </div>
            </div>
  
            <!-- <label for="referencia" class="modaltitle">Referências de apoio</label>
              <input [(ngModel)]="postagem.referencia" class="form-control" name="referencia" id="referencia"
                placeholder="Digite a fonte do conteúdo (opcional)" /> -->
  
          </div>
        </div>
  
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" id="botao-cancelar" data-dismiss="modal">
            Cancelar
          </button>
          <button (click)='publicar()' type="button" class="btn " id="botao-publicar" data-dismiss="modal">
            Publicar
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- /Modal Postagem -->













